export class CartaoCadastroItem {    
    constructor(
        public cedenteContratoId: number,
        public valorPadrao: number,
        public cartaoPeriodoPadrao: number,     
    ) {
    }
}
